import { ErrorTypes, NotificationScopes } from '../AppConstants'
import type { Notification } from '../values/Notification'

const DUPLICATE_POST_SERVER_TEXT =
  'Whoops! Looks like we already posted this one recently!'
const DUPLICATE_POST_MESSAGE =
  "You recently posted this. Unfortunately, we can't post the same content again so soon."
const GENERIC_SAVE_FAILURE_MESSAGE =
  'Failed to save your post. Please try again.'

/**
 * Normalized inline save-failure message for a single channel, shared by the
 * expanded composer (`useSavingError`) and the collapsed channel row so both
 * views surface identical copy: a profile queue-limit error takes precedence,
 * an empty server message becomes a generic fallback, and the raw duplicate-post
 * server text is rewritten to friendly copy. Returns undefined when the channel
 * has no saving error.
 */
export const getSavingErrorMessage = (
  visibleNotifications: Notification[],
  serviceName: string,
): string | undefined => {
  const profileQueueLimitError = visibleNotifications.find(
    (notif) =>
      notif.scope ===
      `${NotificationScopes.PROFILE_QUEUE_LIMIT}-${serviceName}`,
  )?.message

  const savingError = visibleNotifications.find(
    (notif) =>
      notif.scope ===
      `${NotificationScopes.UPDATE_SAVING}-${ErrorTypes.INLINE}-${serviceName}`,
  )

  let savingErrorMessage: string | undefined
  if (savingError) {
    if (!savingError.message) {
      savingErrorMessage = GENERIC_SAVE_FAILURE_MESSAGE
    } else if (savingError.message.includes(DUPLICATE_POST_SERVER_TEXT)) {
      savingErrorMessage = DUPLICATE_POST_MESSAGE
    } else {
      savingErrorMessage = savingError.message
    }
  }

  return profileQueueLimitError || savingErrorMessage
}
